import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MPCCriticality = _resolveComponent("MPCCriticality")!
  const _component_MPFDefault = _resolveComponent("MPFDefault")!
  const _component_MPCGPU = _resolveComponent("MPCGPU")!
  const _component_MPCLocation = _resolveComponent("MPCLocation")!
  const _component_ModalTunnel = _resolveComponent("ModalTunnel")!

  return (_openBlock(), _createBlock(_component_ModalTunnel, {
    visible: _ctx.visible,
    closeOnExternalClick: false,
    nbPages: 3,
    headerProps: {
      closeButton: true,
      displayProgression: true,
    },
    displayNavigation: false,
    ref: "refTunnel",
    width: "700px",
    onClose: _ctx.onClose
  }, {
    [`content-${_ctx.pages.CRITICALITY.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPCCriticality, {
        criticality: _ctx.criticality,
        "onUpdate:criticality": _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('update:criticality', $event);_ctx.goToPage(_ctx.pageKeys.GPU);})
      }, null, 8, ["criticality"])
    ]),
    [`footer-${_ctx.pages.CRITICALITY.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPFDefault, {
        previousLabel: _ctx.pages.CRITICALITY.previousLabel,
        nextLabel: _ctx.pages.CRITICALITY.nextLabel,
        onPrevious: _ctx.onClose,
        onNext: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.GPU)))
      }, null, 8, ["previousLabel", "nextLabel", "onPrevious"])
    ]),
    [`content-${_ctx.pages.GPU.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPCGPU, {
        requireGPU: _ctx.requireGPU,
        "onUpdate:requireGPU": _cache[2] || (_cache[2] = ($event: any) => {_ctx.$emit('update:requireGPU', $event);_ctx.goToPage(_ctx.pageKeys.LOCATION);})
      }, null, 8, ["requireGPU"])
    ]),
    [`footer-${_ctx.pages.GPU.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPFDefault, {
        nextLabel: _ctx.pages.GPU.nextLabel,
        previousLabel: _ctx.pages.GPU.previousLabel,
        onPrevious: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.CRITICALITY))),
        onNext: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.LOCATION)))
      }, null, 8, ["nextLabel", "previousLabel"])
    ]),
    [`content-${_ctx.pages.LOCATION.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPCLocation, {
        selectedCountry: _ctx.selectedCountry,
        "onUpdate:selectedCountry": _cache[5] || (_cache[5] = ($event: any) => {_ctx.onSelectCountry($event);_ctx.onClose();})
      }, null, 8, ["selectedCountry"])
    ]),
    [`footer-${_ctx.pages.LOCATION.pageNum}`]: _withCtx(() => [
      _createVNode(_component_MPFDefault, {
        nextLabel: _ctx.pages.LOCATION.nextLabel,
        previousLabel: _ctx.pages.LOCATION.previousLabel,
        onPrevious: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToPage(_ctx.pageKeys.GPU))),
        onNext: _ctx.onClose
      }, null, 8, ["nextLabel", "previousLabel", "onNext"])
    ]),
    _: 2
  }, 1032, ["visible", "onClose"]))
}